const SELF = '_self';

/**
 * Creates a custom urlOpener for the Amplify Auth Oauth configuration.
 *
 * The Cognito AUTHORIZE endpoint supports IdP discovery based on the email domain
 * of the user email by passing the domain in the `idp_identifier` param, as an alternative
 * to passing the provider name in the `identity_provider` param.
 * The Amplify library does not yet provide a way to set the `idp_identifier` param.
 * This function is a workaround that will rewrite the `identity_provider` param
 * as the `idp_identifier param.`
 *
 * If configured, this will modify the behavior of `Auth.federatedSignIn` to allow
 * passing the user domain as follows:
 * ```
 * await Auth.federatedSignIn({
 *   customProvider: userEmailDomain,
 * });
 * ```
 * @param url the original url to open
 * @returns
 */
export const rewriteUrlOpenerFactory =
  (cognitoDomain: string) =>
  (url: string): Promise<Window | null> => {
    let newUrl = url;
    // only rewrite the AUTHORIZE endpoint
    if (url.startsWith(`https://${cognitoDomain}/oauth2/authorize?`)) {
      newUrl = url.replace('identity_provider=', 'idp_identifier=');
    }

    const windowProxy = window.open(newUrl, SELF);
    if (windowProxy) {
      return Promise.resolve(windowProxy);
    }
    return Promise.reject();
  };
